import { useMemo } from "react";

import Located from "@mapmycustomers/shared/types/base/Located";
import { isMapped } from "@mapmycustomers/shared/util/assert";

export const useLocationUrl = (located: Located) =>
  useMemo(() => {
    let url;
    if (located.address) {
      const fullAddress = [
        located.postalCode,
        located.address,
        located.city,
        located.region,
        located.country,
      ]
        .filter((item) => !!item)
        .join(", ");
      url = `https://maps.google.com?saddr=Current+Location&daddr=${encodeURIComponent(
        fullAddress
      )}`;
    } else if (isMapped(located)) {
      const [long, lat] = located.geoPoint.coordinates;
      url = `https://maps.google.com?saddr=Current+Location&daddr=${lat},${long}`;
    }
    return url;
  }, [located]);
